/*
 * PEARSON PROPRIETARY AND CONFIDENTIAL INFORMATION SUBJECT TO NDA
 * Copyright © 2020 Pearson Education, Inc.
 * All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Pearson Education, Inc.  The intellectual and technical concepts contained
 * herein are proprietary to Pearson Education, Inc. and may be covered by U.S. and Foreign Patents,
 * patent applications, and are protected by trade secret or copyright law.
 * Dissemination of this information, reproduction of this material, and copying or distribution of this software
 * is strictly forbidden unless prior written permission is obtained
 * from Pearson Education, Inc.
 */

import { envParam } from './base';

/**
 * Dev environment overrides.
 */
// const API_BASE_URL = 'https://aiadmin-api-pplus.etext-dev.pearsondev.tech/api/v1';
const BASE_URL = 'https://aiadmin-api-pplus.etext-dev.pearsondev.tech';
const STG_BASE_URL = 'https://aiadmin-api-pplus.etext-stg.pearsondev.tech';
const PROD_BASE_URL = 'https://aiadmin-api-pplus.etext-prd.pearsonprd.tech';
const BERLIN_DEV_URI = 'https://berlin-api-pplus.etext-dev.pearsondev.tech';
const BERLIN_STG_URI = 'https://berlin-api-pplus.etext-stg.pearsondev.tech';
const BERLIN_PROD_URI = 'https://berlin-api-pplus.etext-prd.pearsonprd.tech';
const STACKB_PORT = '8443';
const V1_PATH = '/api/v1';
const V2_PATH = '/api/v2.0';
const V3_PATH = '/api/v3.0';
let STACK_B_BASE_URL;
let BERLIN_URI_FOR_STACK;
switch (envParam) {
  case 'stg':
    STACK_B_BASE_URL = STG_BASE_URL;
    BERLIN_URI_FOR_STACK = BERLIN_STG_URI;
    break;
  case 'prod':
    STACK_B_BASE_URL = PROD_BASE_URL;
    BERLIN_URI_FOR_STACK = BERLIN_PROD_URI;
    break;
  default:
    STACK_B_BASE_URL = BASE_URL;
    BERLIN_URI_FOR_STACK = BERLIN_DEV_URI;
}
const dev = {
  ENVIRONMENT: 'dev',
  PARTNER_ENV: 'dev',
  BERLIN_ENV: 'qa',
  DELAYED_GTM: false,
  GTM_CONTAINER_ID: 'GTM-WTX7GQN',
  GTM_AUTH: 'fhlb6akAre6D68G4ut5Y7A',
  GTM_PREVIEW: 'env-4',
  INT_AZURE_CLIENT_ID: '0257b9a8-eff1-482d-b310-bc7175a92a56',
  INT_BASE_URL: `${BASE_URL}${V1_PATH}`,
  AI_ADMIN_API_BASE_URL: `${BASE_URL}${V1_PATH}`,
  AI_ADMIN_API_BASE_URL_V2: `${BASE_URL}${V2_PATH}`,
  AI_ADMIN_API_BASE_URL_V3: `${BASE_URL}${V3_PATH}`,
  AI_ADMIN_API_BASE_URL_STACKB: `${STACK_B_BASE_URL}:${STACKB_PORT}${V1_PATH}`,
  AI_ADMIN_API_BASE_URL_V2_STACKB: `${STACK_B_BASE_URL}:${STACKB_PORT}${V2_PATH}`,
  AI_ADMIN_API_BASE_URL_V3_STACKB: `${STACK_B_BASE_URL}:${STACKB_PORT}${V3_PATH}`,
  BERLIN_API_URI_STACKB: `${BERLIN_URI_FOR_STACK}:${STACKB_PORT}`,
  BERLIN_GRAPH_ID: '39cd5c40-d55b-4bbe-9ea1-7774142035bf',
  BERLIN_TENANT_ID: '12b793b2-ebae-4058-ad9b-7d8fb5369054',
  BERLIN_TENANT_KEY: '1e0b7cf7-cb64-4861-9834-ef377be8b22a'
};

export default dev;
